module.exports = __webpack_public_path__ + "static/media/stop_share_screen_camera.17cdddb2.svg";